module.exports = __webpack_public_path__ + "static/media/Agri-Entrepreneur Infographic Desktop - GBR Tech - 24-05-2024 C.ab9f9af6.gif";